module.exports = __webpack_public_path__ + "static/img/8.6f7b9e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/8.png
// module id = 1BIW
// module chunks = 0